/** CoStar.Api.ListingMarketplace.SEO.ViewModels.SiteType */
export var SiteType;
(function (SiteType) {
    SiteType[SiteType["None"] = 0] = "None";
    SiteType[SiteType["LoopNet"] = 1] = "LoopNet";
    SiteType[SiteType["CityFeet"] = 2] = "CityFeet";
    SiteType[SiteType["Showcase"] = 4] = "Showcase";
})(SiteType || (SiteType = {}));
/** CoStar.Api.ListingMarketplace.SEO.ViewModels.CountryCode */
export var CountryCode;
(function (CountryCode) {
    CountryCode[CountryCode["None"] = 0] = "None";
    CountryCode[CountryCode["USA"] = 1] = "USA";
    CountryCode[CountryCode["CAN"] = 2] = "CAN";
    CountryCode[CountryCode["GBR"] = 3] = "GBR";
    CountryCode[CountryCode["ESP"] = 4] = "ESP";
    CountryCode[CountryCode["FRA"] = 5] = "FRA";
    CountryCode[CountryCode["DEU"] = 6] = "DEU";
    CountryCode[CountryCode["ITA"] = 7] = "ITA";
    CountryCode[CountryCode["NLD"] = 8] = "NLD";
    CountryCode[CountryCode["PRT"] = 9] = "PRT";
    CountryCode[CountryCode["LVA"] = 10] = "LVA";
    CountryCode[CountryCode["MEX"] = 11] = "MEX";
})(CountryCode || (CountryCode = {}));
/** CoStar.Api.ListingMarketplace.SEO.ViewModels.PopularSearchSortType */
export var PopularSearchSortType;
(function (PopularSearchSortType) {
    PopularSearchSortType[PopularSearchSortType["None"] = 0] = "None";
    PopularSearchSortType[PopularSearchSortType["ListingCount"] = 1] = "ListingCount";
    PopularSearchSortType[PopularSearchSortType["Alphabetical"] = 2] = "Alphabetical";
})(PopularSearchSortType || (PopularSearchSortType = {}));
/** CoStar.Api.ListingMarketplace.SEO.ViewModels.LinkCollectionType */
export var LinkCollectionType;
(function (LinkCollectionType) {
    LinkCollectionType[LinkCollectionType["None"] = 0] = "None";
    LinkCollectionType[LinkCollectionType["State"] = 1] = "State";
    LinkCollectionType[LinkCollectionType["City"] = 2] = "City";
    LinkCollectionType[LinkCollectionType["Postcode"] = 4] = "Postcode";
    LinkCollectionType[LinkCollectionType["ObsoleteNeighborhood"] = 6] = "ObsoleteNeighborhood";
    LinkCollectionType[LinkCollectionType["County"] = 8] = "County";
    LinkCollectionType[LinkCollectionType["Neighborhood"] = 16] = "Neighborhood";
})(LinkCollectionType || (LinkCollectionType = {}));
